import React from 'react';
import { ChatMessage } from '../../types';
import styles from './MessageBubble.module.css'; // Import CSS Modules
import CopyButton from '../common/CopyButton'; // Corrected import for default export
// import { useChatStore } from '../../store/chatStore'; // Removed unused import
import { formatTimestamp } from '../../utils/dateUtils'; // Import the new utility

interface MessageBubbleProps {
  message: ChatMessage;
}

const MessageBubble: React.FC<MessageBubbleProps> = ({ message }) => {
  const isUser = message.sender === 'user';

  // No longer need local handleCopy, CopyButton component handles its own logic

  const validDate = message.created_at ? new Date(message.created_at) : new Date();

  const renderContent = () => (
    <div className={`${styles.content} ${isUser ? styles.userContent : styles.aiContent}`}>
      <span className={`${styles.senderName} ${isUser ? styles.userSenderName : styles.aiSenderName}`}>
        {isUser ? 'Tu' : 'Asistent'}
      </span>
      {message.content}
      {message.isLoading && message.sender === 'ai' && (
        <span className={styles.typingIndicator}>scrie...</span>
      )}
    </div>
  );

  const renderCopyButton = () => {
    if (!isUser && !message.isLoading && message.content) {
      return (
        <div className={styles.copyButtonWrapper}>
          <CopyButton textToCopy={message.content} title="Copiază conținutul mesajului" />
        </div>
      );
    }
    return null;
  };

  return (
    <div className={`${styles.messageBubble} ${isUser ? styles.userBubble : styles.aiBubble}`}>
      {isUser ? (
        renderContent()
      ) : (
        <div className={styles.aiContentWrapper}>
          {renderContent()}
          {renderCopyButton()}
        </div>
      )}
      <span className={`${styles.timestamp} ${isUser ? styles.userTimestamp : styles.aiTimestamp}`}>
        {formatTimestamp(validDate)}
      </span>
    </div>
  );
};

export default MessageBubble; 